import React, { useEffect } from 'react'
import { Box, Button, Typography } from '@mui/material'

//components
import AuthLayout from 'components/layout/Auth'
import GoogleAuthButton from 'components/auth/GoogleAuthButton'
import AuthorizationTerms from 'components/AuthorizationTerms'
//constants
import { AUTHORIZATION_STATE } from 'constants/index'
//hooks
import useQueryIsIPAddressBanned from 'hooks/useQueryIsIPAddressBanned'
import useAuthorization from 'hooks/useAuthorization'
//types
import { AuthorizationContentProps } from 'types'

const Content = ({ signUpParams, setState, segmentConfig }: AuthorizationContentProps) => {
  const { isBanned } = useQueryIsIPAddressBanned()
  const { handleAuthorization, handleSignupAuthorization, trackSignupScreenView } =
    useAuthorization(isBanned, signUpParams)

  useEffect(() => {
    trackSignupScreenView()
  }, [trackSignupScreenView])

  const generatePageContent = () => {
    const pageContent = {
      title: 'Limited Time',
      text: (
        <Typography variant="h3" sx={styles.text}>
          Sign up today to start earning rewards for all of your future mobile game purchases!
        </Typography>
      ),
      image: <img src="/images/authorizationImage.png" className="authorizationImage" />,
    }

    if (segmentConfig.config) {
      pageContent.title = `${segmentConfig.config.segmentGameName} welcomes you to Playback!`

      pageContent.text = (
        <Typography variant="h3" sx={styles.text}>
          Create a Playback account to start winning rewards from mobile games.
        </Typography>
      )
    }

    return pageContent
  }
  const pageContent = generatePageContent()

  return (
    <AuthLayout>
      <div>
        {pageContent.image}
        <div className="authorizationContent">
          <Typography variant="h1" sx={styles.title}>
            {pageContent.title}
          </Typography>
          {pageContent.text}
          <div className="authorizationContentActionsButtons">
            <GoogleAuthButton handleClick={handleSignupAuthorization} />
            <Button
              sx={{ ...styles.button, ...styles.authorizationButton }}
              onClick={() => setState(AUTHORIZATION_STATE.DONT_HAVE)}
            >
              <Typography variant="h4" sx={styles.authorizationButtonText}>
                Don't have a gmail account?
              </Typography>
            </Button>
          </div>
        </div>
      </div>
      <div>
        <Box sx={styles.footer}>
          <Button sx={styles.button} onClick={handleAuthorization}>
            <Typography variant="h4" sx={styles.authorizationButtonText}>
              Already have an account? <strong>Log in</strong>
            </Typography>
          </Button>
          <AuthorizationTerms />
        </Box>
      </div>
    </AuthLayout>
  )
}

const styles = {
  text: { fontWeight: 400, marginBottom: '30px' },
  title: {
    fontWeight: 600,
    marginBottom: '24px',
  },
  button: {
    padding: '7px 24px',
    width: '100%',
    margin: '0 auto',
    background: 'none',
    textAlign: 'center',
    color: '#71717a',
    textTransform: 'none',
    borderRadius: '100px',
    fontWeight: 500,
  },
  authorizationButton: {
    padding: '12px 24px',
    textDecoration: 'underline',
    textUnderlinePosition: 'under',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  authorizationButtonText: {
    fontWeight: 400,
    fontFamily: 'var(--inter-font)',
    color: '#71717A',
  },
  footer: {
    marginBottom: '17px',
  },
}

export default Content
